import { render, staticRenderFns } from "./DeleteRecruiter.vue?vue&type=template&id=612f0732&"
import script from "./DeleteRecruiter.vue?vue&type=script&lang=js&"
export * from "./DeleteRecruiter.vue?vue&type=script&lang=js&"
import style0 from "./DeleteRecruiter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports